import { createFileRoute } from '@tanstack/react-router'
import EvaluationPromptEdit from '@/features/evaluation-prompts/evaluation-prompt-edit'

export const Route = createFileRoute(
  '/_authenticated/evaluation-prompt/$promptId/edit'
)({
  component: EvaluationPromptEdit,
})
